module.exports = __webpack_public_path__ + "img/xzgl_banner.f75c380f.png";